import { useNavigate } from "react-router-dom";
import Html from "./Html";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../redux/actions/user";

const Footer = ({ setIsOpen, isOpen }) => {
  const history = useNavigate()
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user)

  const Logout = () => {
    dispatch(logout());
    sessionStorage.removeItem("token")
    localStorage?.removeItem("route")
    localStorage?.removeItem("permissions")
    history("/login")
  }

  return (
    <Html
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      user={user}
      Logout={Logout}
    />
  );
};

export default Footer;